

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import ScreenLocker from '@/components/ScreenLocker.vue';
import eventBus from '../../utils/eventBus';
import { isRemoteLoading } from '@/utils/remote-loading';

@Component({
  components: {
    ScreenLocker
  }
})
export default class Modal extends Vue {
  @Prop() title!: string;
  @Prop() message!: string;
  @Prop() icon!: string;
  @Prop() confirmText!: string;
  @Prop({ default: 'onConfirm' }) confirmEvent!: string;
  @Prop() cancelText!: string;
  @Prop({ default: false }) hideCancelButton!: boolean;
  @Prop() buttonDisabled!: boolean;
  @Prop({ required: false, default: true }) showButtons!: boolean;
  @Prop({ default: false }) customSize!: boolean;
  @Prop({ default: false }) noBackground!: boolean;
  @Prop({ default: false }) centralizeContent!: boolean;
  @Prop({ default: false }) mobileFullScreen!: boolean;
  @Prop({ default: false }) mobilePositionBottom!: boolean;
  @Prop({ default: false }) disableModalBehaviourMobile!: boolean;
  @Prop({ default: false }) fullWidth!: boolean;
  @Prop({ default: false }) removeBackground!: boolean;

  top: number = 0;
  left: number = 0;

  internalConfirmText: string = '';
  internalCancelText: string = '';
  internalHideCancelButton: boolean = this.hideCancelButton;
  internalButtonDisabled: boolean = this.buttonDisabled || false;

  modalVisible: boolean = false;
  contentVisible: boolean = false;

  get modalStyle() {
    if (!this.isRemoteLoading) return {};

    return {
      position: 'absolute',
      left: 'calc(50% - 160px)',
      top: `${this.top}px`,
      transform: 'translateX(-50%)',
      marginLeft: `${this.left}px`
    };
  }

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  get isMobile() {
    return this.$mobileCheck();
  }

  created() {
    this.internalConfirmText = this.confirmText;
    this.internalCancelText = this.cancelText;
  }

  get iconValue() {
    return `icon-${this.icon}`;
  }

  confirmClicked() {
    eventBus.$emit(this.confirmEvent, true);

    this.close();
  }

  closeModal() {
    eventBus.$emit(this.confirmEvent, false);

    this.close();
  }

  close() {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    this.modalVisible = false;
    this.contentVisible = false;
    setTimeout(() => {
      this.$emit('onClose');
      eventBus.$emit('closedModal');
    }, 300);
  }

  disableScroll() {
    const scrollY = window.scrollY;
    const { body } = document;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.right = '0px';
    body.style.left = '0px';
    if (this.mobileFullScreen) {
      body.classList.add('hidden');
    }
  }

  updateModalPosition() {
    try {
      const modal = this.$refs.modal as HTMLElement;
      if (!modal || !isRemoteLoading()) return;

      const scrollElement = window.parent.document.getElementById(
        'main-content'
      );

      const parentScrollY = scrollElement ? scrollElement.scrollTop : 0;
      const viewportHeight = window.parent.innerHeight;
      const modalHeight = modal.offsetHeight || 0;
      const modalWidth = modal.offsetWidth || 0;

      const iframeRects = window.frameElement
        ? window.frameElement.getBoundingClientRect()
        : { top: 0, width: 0 };
      const iframeOffsetTop = iframeRects.top || 0;

      const top =
        parentScrollY -
        (parentScrollY + iframeOffsetTop) +
        (viewportHeight / 2 - modalHeight / 2);

      const left =
        iframeRects.width - modalWidth < 320 || this.fullWidth ? 0 : -160;

      this.top = Math.max(top, 0);
      this.left = left;
    } catch (err) {
      console.error('[CenteredModal] Failed to update position:', err);
    }
  }

  messageUpdateModalPosition(event: MessageEvent) {
    if (event.data.type === 'updateModalPosition') {
      this.updateModalPosition();
    }
  }

  mounted() {
    this.updateModalPosition();

    window.addEventListener('resize', this.updateModalPosition);
    window.addEventListener('message', this.messageUpdateModalPosition);

    this.$nextTick(() => {
      this.disableScroll();
      this.modalVisible = true;
      setTimeout(() => {
        this.contentVisible = true;
      }, 50);
    });
  }

  beforeDestroy() {
    window.removeEventListener('message', this.messageUpdateModalPosition);
    window.removeEventListener('resize', this.updateModalPosition);
  }
}
